import React, { useRef, useEffect, useState, useCallback } from "react";
import { Terminal } from "@xterm/xterm/lib/xterm";
import {
  handleCommand,
  welcomeMessage,
  handleBackspace,
  handleLeftArrow,
  handleRightArrow,
} from "../utils/CommandResponses";

import "@xterm/xterm/css/xterm.css";
import "../styles.css";

const TerminalWindow = (props) => {
  const terminalRef = useRef(null);
  const term = useRef(new Terminal());

  const [commandInput, setCommandInput] = useState("");
  const [terminalHistory, setTerminalHistory] = useState([""]);
  const historyRef = useRef(terminalHistory);

  const mobileScreenSize = window.matchMedia("(max-width: 1024px)").matches;

  const { isMobile, setTerminalOpen } = props;

  useEffect(() => {
    historyRef.current = terminalHistory; // change the ref whenever the history state changes
  }, [terminalHistory]);

  const handleHistoryUp = useCallback((term) => {
    // return the previous command in history
    const curr = historyRef.current;
    if (curr.length === 0) {
      return "";
    }

    let toWrite = "";
    const cmd = term.buffer.active
      .getLine(term.buffer.active.baseY + term.buffer.active.cursorY)
      ?.translateToString()
      .split("$")[1]
      ?.trim();

    if (cmd.length !== 0) {
      toWrite += "\b \b".repeat(cmd.length);
    }
    toWrite += curr[0];
    setTerminalHistory((prev) => {
      return prev.slice(1).concat(prev[0]);
    });
    return toWrite;
  }, []);

  const handleHistoryDown = useCallback((term) => {
    // return the previous command in history
    const curr = historyRef.current;
    if (curr.length === 0) {
      return "";
    } else if (curr.length === 1) {
      return curr[0];
    }

    let toWrite = "";
    const cmd = term.buffer.active
      .getLine(term.buffer.active.baseY + term.buffer.active.cursorY)
      ?.translateToString()
      .split("$")[1]
      ?.trim();

    if (cmd.length !== 0) {
      toWrite += "\b \b".repeat(cmd.length);
    }
    toWrite += curr[curr.length - 2];

    setTerminalHistory((prev) => {
      return [prev[prev.length - 1]].concat(prev.slice(0, prev.length - 1));
    });
    return toWrite;
  }, []);

  const onChangeHandler = (e) => {
    setCommandInput(e.target.value.toLowerCase());
  };

  const onSubmitCommandHandler = (e) => {
    if (e.nativeEvent.key === "Enter") {
      term.current.write(commandInput.trim());
      setTimeout(() => {
        handleCommand(
          term.current,
          setTerminalHistory,
          historyRef,
          setTerminalOpen
        );
        term.current.prompt();
      }, 100);

      setCommandInput("");
    }
  };

  useEffect(() => {
    // Initialize a new xterm Terminal instance
    const IterminalOptions = {
      theme: {},
      rows: isMobile ? 25 : 38,
      fontSize: isMobile ? 13 : 15,
      fontFamily:
        '"Menlo for Powerline", Menlo, Consolas, "Liberation Mono", Courier, monospace',
      cursorBlink: true,
      scrollback: 150,
      scrollSensitivity: 0.3,
      lineHeight: 1,
    };
    term.current = new Terminal(IterminalOptions);

    // Attach the terminal to the div using the open() method
    term.current.open(terminalRef.current);
    term.current.focus();

    // Write some text in the terminal as a welcome message
    welcomeMessage(term.current);

    // Optional: Handle terminal input and commands
    term.current.prompt = () =>
      term.current.write(
        "\r\n\x1b[34mguest\x1b[32m@myportfolio\x1b[36m:\x1b[36m~ \x1b[0m$ "
      );
    term.current.prompt();

    term.current.onKey(({ key, domEvent }) => {
      // console.log(domEvent.key);

      if (domEvent.key === "Enter") {
        handleCommand(
          term.current,
          setTerminalHistory,
          historyRef,
          setTerminalOpen
        );
        term.current.prompt();
      } else if (domEvent.key === "ArrowUp") {
        console.log("HISTORY UP");
        const cmd = handleHistoryUp(term.current);
        console.log(cmd);
        term.current.write(cmd);
        return;
      } else if (domEvent.key === "ArrowDown") {
        console.log("HISTORY DOWN");
        const cmd = handleHistoryDown(term.current);
        console.log(cmd);
        term.current.write(cmd);
        return;
      } else if (domEvent.key === "ArrowLeft") {
        handleLeftArrow(term.current, key);
      } else if (domEvent.key === "ArrowRight") {
        handleRightArrow(term.current, key);
      } else if (domEvent.key === "Backspace") {
        handleBackspace(term.current);
      } else {
        term.current.write(key); // Allow user to type into the terminal
      }
    });

    // Cleanup terminal on component unmount
    return () => term.current.dispose();
  }, [isMobile, handleHistoryUp, handleHistoryDown, setTerminalOpen]);

  return (
    <React.Fragment>
      <div className="terminal-window" ref={terminalRef}></div>
      {(isMobile || mobileScreenSize) && (
        <input
          className="mobile-terminal-input"
          value={commandInput}
          autoCapitalize="off"
          onChange={onChangeHandler} // for writing the command
          onKeyDown={onSubmitCommandHandler} // Backspace and Enter handler
          placeholder=">__"
        />
      )}
    </React.Fragment>
  );
};

export default TerminalWindow;
